import { getAuthSelfQueryOptions } from '@api/endpoints/auth/get-auth-self'
import { isManagerOrAbove } from '@core/utils/role-utils'
import { ROUTES } from '@platform/router/paths'
import type { QueryClient } from '@tanstack/react-query'
import { redirect } from '@tanstack/react-router'

export async function requireManager(
  queryClient: QueryClient,
  workspaceId: string
) {
  const { roles } = await queryClient.ensureQueryData(getAuthSelfQueryOptions())

  if (!isManagerOrAbove(roles, workspaceId))
    throw redirect({ to: ROUTES.workspaceRoot, params: { workspaceId } })
}
